export default __webpack_public_path__ + "static/media/success_islamic.86955f02.gif";